// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__6gUJE","copyright":"Footer_copyright__3EoAi"};